import {
    Component,
    Inject,
    input,
    OnInit,
    ChangeDetectionStrategy,
} from '@angular/core';
import {
    FormGroup,
    FormBuilder,
    FormControl,
    FormArray,
    ReactiveFormsModule,
} from '@angular/forms';
import { Apollo, gql, QueryRef } from 'apollo-angular';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {
    GetProductLocalesDocument,
    GetProductLocalesQuery,
    UpdateProductAiLocaleDocument,
    UpdateProductAiLocaleMutation,
} from 'src/__generated__/graphql';

const COLUMNS_SCHEMA = [
    {
        key: 'description',
        type: 'text',
        label: 'Description',
    },
    {
        key: 'title',
        type: 'text',
        label: 'Title',
    },
    {
        key: 'locale',
        type: 'text',
        label: 'Locale',
    },
    {
        key: 'action',
        type: 'text',
        label: 'action',
    },
];

@Component({
    selector: 'app-productlocales',
    templateUrl: './product-locales.component.html',
    styleUrl: './product-locales.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ReactiveFormsModule,
        MatFormFieldModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
    ],
})
export class ProductlocalesComponent implements OnInit {
    isEditableNew: boolean = true;
    productId = input.required<string>();
    isLoading = true;
    public VOForm!: FormGroup;
    productLocalesQuery?: QueryRef<GetProductLocalesQuery>;
    productLocalesSubscription?: Subscription;
    productLocales = new MatTableDataSource<any>();
    public mappingGroup!: FormGroup;
    columnsSchema: any = COLUMNS_SCHEMA;
    displayedColumns: string[] = COLUMNS_SCHEMA.map((col) => col.key);
    constructor(
        private apollo: Apollo,
        private fb: FormBuilder,
        private _formBuilder: FormBuilder,
    ) {}

    ngOnInit(): void {
        this.LoadData();
    }

    EditSVO(VOFormElement: any, i: any) {
        VOFormElement.get('VORows').at(i).get('isEditable').patchValue(false);
    }

    SaveVO(VOFormElement: any, i: any) {
        VOFormElement.get('VORows').at(i).get('isEditable').patchValue(true);
        console.log(
            'description',
            VOFormElement.get('VORows').at(i).get('description').value,
        );
        console.log(
            'locale',
            VOFormElement.get('VORows').at(i).get('locale').value,
        );
        var description = VOFormElement.get('VORows')
            .at(i)
            .get('description').value;
        var locale = VOFormElement.get('VORows').at(i).get('locale').value;
        var title = VOFormElement.get('VORows').at(i).get('title').value;

        this.apollo
            .mutate<UpdateProductAiLocaleMutation>({
                mutation: UpdateProductAiLocaleDocument,
                errorPolicy: 'all',
                variables: {
                    input: {
                        productId: parseInt(this.productId()),
                        description: description,
                        title: title,
                        locale: locale,
                    },
                },
            })
            .subscribe(
                ({ data }) => {},
                (error) => {
                    console.log('error', JSON.stringify(error));
                },
            );
    }

    CancelSVO(VOFormElement: any, i: any) {
        VOFormElement.get('VORows').at(i).get('isEditable').patchValue(true);
    }

    LoadData() {
        this.VOForm = this.fb.group({
            VORows: this._formBuilder.array([]),
        });

        this.productLocalesQuery =
            this.apollo.watchQuery<GetProductLocalesQuery>({
                query: GetProductLocalesDocument,
                fetchPolicy: 'network-only',
                variables: {
                    where: { productIds: { in: this.productId() } },
                },
            });
        this.productLocalesSubscription =
            this.productLocalesQuery.valueChanges.subscribe((result) => {
                var dataFound =
                    result?.data?.marketplaceProductSearch?.items?.[0]
                        ?.locales ?? [];

                this.VOForm = this.fb.group({
                    VORows: this.fb.array(
                        dataFound.map((val) =>
                            this.fb.group({
                                description: new FormControl(val.description),
                                title: new FormControl(val.title),
                                locale: new FormControl(val.locale),
                                action: new FormControl('existingRecord'),
                                isEditable: new FormControl(true),
                            }),
                        ),
                    ),
                });

                this.isLoading = false;
                this.productLocales = new MatTableDataSource(
                    (this.VOForm.get('VORows') as FormArray).controls,
                );
            });
    }
}
